import { render, staticRenderFns } from "./ColorItem.vue?vue&type=template&id=20a38e5f&scoped=true&"
import script from "./ColorItem.vue?vue&type=script&lang=js&"
export * from "./ColorItem.vue?vue&type=script&lang=js&"
import style0 from "./ColorItem.vue?vue&type=style&index=0&id=20a38e5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a38e5f",
  null
  
)

export default component.exports